import { ActionIcon } from "PFComponents/action_icon";
import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Pill } from "PFComponents/pill";
import { Typography } from "PFComponents/typography";
import { CustomValueTag } from "PFCore/types";

import css from "./custom_value_tag_pill.module.scss";

type CustomValueTagPillProps = {
  tag: CustomValueTag;
  onRemove?: (tag: CustomValueTag) => void;
};

export const CustomValueTagPill = ({ tag, onRemove }: CustomValueTagPillProps) => (
  <Pill small>
    <Inline gap="spacingSm" alignItems="center">
      {onRemove && <ActionIcon name="cross" size="xxs" onClick={() => onRemove(tag)} />}
      <Typography
        variant="labelRegular"
        tag="span"
        className={css.tagText}
        title={tag.displayAs}
        clipOverflow
      >
        {tag.displayAs}
      </Typography>
      <Icon name={tag.iconName} size="xxs" color="paletteBlue0" />
    </Inline>
  </Pill>
);
